import PreviewStylesCss from "../../../styles/PreviewStyles.css";
import TableStyles from "../../../styles/TableStyles.css";
import CommonStyles from "../../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...PreviewStylesCss,
  ...TableStyles,
  ...CommonStyles,
  artworkDiv:{
    background: "#424242",
    borderRadius: "4px 0px 4px 4px",
    padding: "10px",
    borderBottom: "1px solid #676767",
},
nonMCPSPPL: {
  color: "red",
},

globalCreateInput:{
  "& .onlyPopup":{
    position:"relative"
  }
},
popOutBlock:{
  background:"#424242",
  textAlign:"center",
  flex: "1",
  "& button":{
    fontSize:"12px",
    margin:"7px 11px 7px 0",
    background:"#0c853e",
    display:"block",
    padding:"13px 10px",
    width:"100%",
    "&:hover":{
      background:"#04923F",
    },
    "& svg":{
      fontSize:"2em",
      display:"block",
    margin:"0 auto 5px auto"
    },
    "& img":{
      display:"block",
    margin:"0 auto"
    }
  },
},
muLabelsTrackPopOut: {
  minWidth: "170px",
  width:"inerit",
  textTransform: "uppercase",
  color: "#dcdcdc",
  fontSize: "0.7em",
  display: "inline-block",
  verticalAlign: "top",
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft:"0"
},
 muListWrap: {
    padding: " 20px 10px",
    height: "calc(100% - 310px)",
    overflow: "auto",
    position: "absolute",
    width: "100%",
    top: "0",
    overflowX: "hidden",
    background: " #353535",
  },
  muTitle: {
    color: "#fff",
    fontSize: "0.88em",
    fontWeight: "500",
    width: "-webkit-fill-available",
    width:"100%",
    padding: "10px 15px 10px 20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: "0",
    whiteSpace: "nowrap",
  },
muDetails: {
    width: "80%",
    display: "inline-block",
    verticalAlign: "top",
    fontSize: "0.75em",
    wordBreak:"break-word",
    "& .MuiChip-root":{
      maxWidth: "192px",
    }
  },

  muLabelsBold: {
    fontWeight: "bold",
  },

  muDetailsBold: {
    fontWeight: "bold",
  },
 
  artworkHolder:{
    position:"relative",
    outline:"none",
    "&:hover > button":{
      display:"inline-block",
      opacity:"1"
    },
    "&:focus > button":{
      display:"inline-block",
      outline:"none",
      opacity:"1"
    },
    "&:active > button":{
      display:"inline-block",
      outline:"none",
      opacity:"1"
    },
    "&:hover >  span":{
      display:"inline-block",
      opacity:"1"
    },
    "& > span":{       
      width: "40px",
      height: "40px",  
      position: "absolute",
      // display:"none",
      opacity:"0",
      right: "45%",
      top: "40%",
      "&.Mui-focusVisible":{
        opacity:"1"
      }
    },
      "& button":{
        background: "#008135",
        width: "40px",
        height: "40px",
        boxShadow:"0 0 3px #000",
        "&:hover":{
          background: "#000",
        },
        position: "absolute",
        // display:"none",
        opacity:"0",
        right: "45%",
        top: "40%",
        "&.Mui-focusVisible":{
          opacity:"1"
        }
      },
      // Added Breakpoints
      [theme.breakpoints.down("sm")]: {
      "& img":{
        width:"100%",
        height:"auto",
      }
      },
      [theme.breakpoints.up("md")]: {
        "& img":{
          width:"100% !important",
          height:"auto !important",
        }
      },
      [theme.breakpoints.up("lg")]: {
        "& img":{
          width:"160px!important",
          height:"160px !important",
        },
        "& .emptyArtwork":{
          width:"160px !important",
          height:"auto !important",
        },
      },
      "& .notPermitted":{
        position: "absolute",
        top: "50%",
        right: "0",
        bottom: "0",
        height: "18px",
        width: "18px",
        left: "0",
        margin: "0 auto",
        background:" rgba(0,0,0,0.5)",
        padding: "10px",
        borderRadius: "50px",
      }
       
  },
});
